import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconTextIndicator: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"text-indicator"} maskId="square-filled-radius-0-stroke-1-IconTextIndicator"><path fillRule="evenodd" clipRule="evenodd" d="M16 3H21V4H19V20H21V21H16V20H18V4H16V3ZM3 5H14V6H9V19H8V6H3V5Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconTextIndicator;
